import { Action, createReducer, on } from '@ngrx/store';
import { CountryUS } from '@shared/models';
import * as dayjs from 'dayjs';

import * as trustActions from '../../actions/trust/trust.actions';

export interface TrustState {
  trustName: string;
  trustDate?: string;
  numberQuestion: string;
  countryQuestion: CountryUS;
  taxResidencyQuestion: CountryUS;
  grantorQuestion?: CountryUS;
  trustAddress: boolean;
  address?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  mailingAddress: boolean;
  mailAddress?: string;
  mailZipCode?: string;
  mailCity?: string;
  mailState?: string;
}

export const initialState: TrustState = {
  trustName: '',
  trustDate: '',
  numberQuestion: '',
  countryQuestion: CountryUS.EMPTY,
  taxResidencyQuestion: CountryUS.EMPTY,
  grantorQuestion: CountryUS.EMPTY,
  trustAddress: false,
  address: '',
  zipCode: '',
  city: '',
  state: '',
  mailingAddress: false,
  mailAddress: '',
  mailZipCode: '',
  mailCity: '',
  mailState: '',
};

const trustReducer = createReducer(
  initialState,
  on(trustActions.TrustUpdate, (_state, { payload }) => ({
    ...payload,
    ...(payload.trustDate && { trustDate: dayjs(payload.trustDate).format('MM/DD/YYYY') }),
  })),
);

export function reducer(state: TrustState, action: Action) {
  return trustReducer(state, action);
}
